import { connect } from 'react-redux';
import { redux } from '../api';

import ChartsWithData from './ChartsWithData.js';

const { setUserInfo } = redux.actions;
const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  return {
    viewportData: state.viewports.viewportSpecificData,
    context: state.ui.heatmapContext,
    server: activeServer,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onUserInfoUpdated: user => {
      dispatch(setUserInfo(user));
    },
  };
};

const ConnectedCharts = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChartsWithData);

export default ConnectedCharts;
